export const SET_LOGGED_IN = 'SET_LOGGED_IN';
export const SET_USER_DATA = 'SET_USER_DATA';